import React, {Fragment} from 'react';

import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';

import {IconButton, Box} from '@material-ui/core';

import projectLogo from '../../../assets/images/logos/logo_header_small.svg';

import {
    setActiveLink,
    setSidebarToggle,
    setSidebarToggleMobile
} from '../../../vendors/actions/layout';

import MenuOpenRoundedIcon from '@material-ui/icons/MenuOpenRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';

interface OwnProps {

}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    setSidebarToggle?: (data: any) => void;
    setSidebarToggleMobile?: (data: any) => void;
    setActiveLink: (data: any) => void;
}

const SidebarHeader = (props: any) => {
    const toggleSidebar = () => {
        props.setSidebarToggle(!sidebarToggle);
    };
    const toggleSidebarMobile = () => {
        props.setSidebarToggleMobile(!sidebarToggleMobile);
    };

    const {
        sidebarToggleMobile,
        sidebarToggle,
        sidebarHover,
    } = props.Layout;

    return (
        <Fragment>
            <div
                className={clsx('app-sidebar-header', {
                    'app-sidebar-header-close': sidebarToggle && !sidebarHover
                })}>
                <Box
                    className="header-logo-wrapper"
                    title="Consumer">
                    <Link to="/dashboard" onClick={() => {props.setActiveLink('/dashboard'); toggleSidebarMobile()}} className="header-logo-wrapper-link">
                        <IconButton
                            color="primary"
                            size="medium"
                            className="header-logo-wrapper-btn">
                            <img
                                className="app-sidebar-logo"
                                alt="Carolina React Admin Dashboard with Material-UI PRO"
                                src={projectLogo}
                            />
                        </IconButton>
                    </Link>
                    <Link to="/dashboard" onClick={() => {props.setActiveLink('/dashboard'); toggleSidebarMobile()}}>
                        <Box className="header-logo-text">And<span>Lawyers</span></Box>
                    </Link>
                </Box>
                <Box
                    className={clsx('app-sidebar-header-btn', {
                        'app-sidebar-header-btn-close': sidebarToggle && !sidebarHover
                    })}>
                    <IconButton color="inherit" onClick={toggleSidebar} size="medium">
                        {sidebarToggle ? <MenuRoundedIcon/> : <MenuOpenRoundedIcon/>}
                    </IconButton>
                </Box>
                <Box className="app-sidebar-header-btn-mobile">
                    <IconButton
                        color="inherit"
                        onClick={toggleSidebarMobile}
                        size="medium">
                        {sidebarToggleMobile ? (
                            <MenuOpenRoundedIcon/>
                        ) : (
                            <MenuRoundedIcon/>
                        )}
                    </IconButton>
                </Box>
            </div>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout} = state;
    return {User, Layout}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setSidebarToggle: (data: any) => dispatch(setSidebarToggle(data)),
        setSidebarToggleMobile: (data: any) => dispatch(setSidebarToggleMobile(data)),
        setActiveLink: (data: number) => dispatch(setActiveLink(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeader);
